export default [
  { title: "ЕВРО", deaultValues: true },
  { title: "ДРУГОЕ", deaultValues: false },
  { title: "ИНОЕ", deaultValues: false },
];